import { useEffect, useState } from "react";
import { Text } from "@ui-component-library";
import { fetchPosts } from "../../api/services/posts";

const PostsBigV2 = (props) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchData();
  }, [props.category, props.pageSize, props.pageNr]);

  const fetchData = async () => {
    const posts = await fetchPosts({pagesize: props.pageSize, pageNr: props.pageNr, category: props.category.value});
    setPosts(posts.data.posts);
  };

  return (
    <>
      <section className="w-full py-24 container">
        <Text variant="title-lg/leading-8/medium" className="text-[#0F0F0F] mb-12">{props.title}</Text>

        <div className="grid grid-cols-1 gap-x-6 gap-y-6 md:gap-y-[96px] md:grid-cols-2">
          {posts?.map((post) => (
            <div key={post.id} className="cursor-pointer" onClick={() => window.location.href=post.url}>
              <div className="rounded-[16px] aspect-square overflow-hidden">
                <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" />
              </div>

              <div className="mt-4">
                <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">{post.category_name}</Text>

                <Text variant="text-xl/leading-normal/medium" className="text-[#1A1A1A] my-3">{post.title}</Text>

                <Text variant="text-base/leading-normal/normal" className="text-[#737373]">{post.description}</Text>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

PostsBigV2.defaultProps = {
  category: {label: 'Allt', value: 'Allt'},
  pageSize: 3,
  pageNr: 1,
  title: "Headline that solves user's main problem",
};

PostsBigV2.fields = {
  category: {type: "external",
    fetchList: async () => {
      const resp = await fetch("/admin-api/category/");
      const resp_json = await resp.json();
      return resp_json.map((cat) => {return {"label": cat.name, "value": cat.id}});
    },
  },
  pageSize: {
    type: "number",
  },
  pageNr: {
    type: "number",
  },
  title: {
    type: "text",
    label: "Title",
  },
};

export default PostsBigV2;
